import React, {useEffect, useState} from "react";
import Footer from "../../component/Footer";
import "./campaigns.css";
import {useHistory} from "react-router-dom";
import {getActiveCampaigns} from "../../util/APIUtils";
import LoadingIndicator from "../../component/LoadingIndicator/";
import {showAxiosError, createImageUrl} from "../../util/Helpers";
import ReactHtmlParser from "react-html-parser";
import {VirtualHost} from "../../constants";
import "../../util/explorer_support";
import {Pagination} from "antd";

function Campaigns() {
    let history = useHistory();
    const [campaign, setCampaign] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(0);
    const [pageSize, setPageSize] = useState(12);
    const [contentTotalSize, setContentTotalSize] = useState(0)
    useEffect(() => {
        getCampaignAPI(pageNumber, pageSize);
    }, []);

    function getCampaignAPI(pageNumber, pageSize) {
        setLoading(true);
        getActiveCampaigns(pageNumber, pageSize).then((response) => {
            setLoading(false);
            setCampaign(response.data.content);
            setContentTotalSize(response.data.totalElements);
        }).catch(error => {
            showAxiosError(error.response);
            setLoading(false);
        });
    }

    function replacePercentageToBold(header) {
        if (header === null || header === "") {
            return header;
        }

        let first = header.indexOf("%");
        if (first > 0) {
            let second = header.indexOf(" ", first);
            return header.substring(0, first) + ("<b>" + header.substring(first, second) + "</b>") + header.substring(second);
        } else {
            return header;
        }
    }

    function replaceCompanyName(header) {
        if (header === null || header === "") {
            return header;
        }
        return header.replaceAll("[companyName]", VirtualHost.companyName)
    }

    return loading ? (
        <LoadingIndicator/>
    ) : (
        <div>
            <section className="u-clearfix u-section-1" id="sec-deac">
                <div className="u-clearfix u-sheet u-sheet-1 campaign-title-area">
                    <h1 className="u-custom-font u-font-oswald u-text u-text-custom-color-1 u-text-default u-text-1">
                        {" "}
                        Kampanyalar
                    </h1>
                    <h4 className="u-align-center u-custom-font u-font-oswald u-text u-text-2 campaign-title">
                        {" "}
                        {VirtualHost.companyName} ile en avantajlı fırsatlardan yararlanın,&nbsp;
                        <br/>
                        kampanyaları kaçırmayın.
                    </h4>
                </div>
            </section>
            <section className="u-clearfix u-section-2" id="sec-4b5c">
                <div className="u-expanded-width u-list u-list-1">
                    <div className="u-repeater u-repeater-1">
                        {campaign.map((item) => {
                            return (
                                <div
                                    key={item.recordId}
                                    className="u-align-center u-container-style u-list-item u-repeater-item"
                                >
                                    <div
                                        onClick={() => {
                                            history.push(`/Kampanya-Detay/${item.recordId}`);
                                        }}
                                        className="u-container-layout u-similar-container u-valign-top u-container-layout-1 c-pointer"
                                    >
                                        <div style={{height: 246.65, marginBottom: "30px"}}>
                                            <img
                                                alt=""
                                                className="u-expanded-width u-image u-image-contain u-image-default u-image-1"
                                                data-image-width="1805"
                                                data-image-height="794"
                                                src={createImageUrl(item, "campaignImage")}
                                            />
                                        </div>
                                        <h6 className="u-custom-font u-font-oswald u-text u-text-2">
                                            {ReactHtmlParser(replaceCompanyName(replacePercentageToBold(item.baseHeader)))}
                                        </h6>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div>
                        <Pagination
                            style={{display: "flex", justifyContent: "center", alignContent: "center"}}
                            current={pageNumber + 1}
                            showSizeChanger
                            total={contentTotalSize}
                            pageSize={pageSize}
                            pageSizeOptions={[12, 18, 24, 30, 45, 60]}
                            onChange={(page, pageSize) => {
                                setPageNumber(page -1);
                                setPageSize(pageSize)
                                getCampaignAPI(page - 1, pageSize);
                            }}
                        />
                    </div>
            </section>
            <Footer/>
        </div>
    );
}

export default Campaigns;



// WEBPACK FOOTER //
// ./src/page/campaigns/index.js